export default "__VITE_ASSET__BdnFLp2L__"